import type { OpportunityCluster } from '../../types';

interface ClusterTooltipProps {
  cluster: OpportunityCluster;
  x: number;
  y: number;
}

export default function ClusterTooltip({ cluster, x, y }: ClusterTooltipProps) {
  return (
    <div
      className="fixed pointer-events-none z-30 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-3 w-64"
      style={{ left: x + 12, top: y - 10 }}
    >
      <div className="font-semibold text-gray-900 dark:text-gray-100 text-sm mb-1">{cluster.label}</div>
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        Score: <span className="font-bold text-orange-600 dark:text-orange-400">{cluster.opportunityScore}</span>
      </div>
      <div className="grid grid-cols-3 gap-2 text-xs">
        <div>
          <div className="flex items-center gap-1">
            <span className="h-2 w-2 rounded-full bg-green-500" />
            <span className="text-gray-500 dark:text-gray-400">Blast</span>
          </div>
          <div className="font-medium text-gray-900 dark:text-gray-100">{cluster.blastCount}</div>
        </div>
        <div>
          <div className="flex items-center gap-1">
            <span className="h-2 w-2 rounded-full bg-red-500" />
            <span className="text-gray-500 dark:text-gray-400">Competitor</span>
          </div>
          <div className="font-medium text-gray-900 dark:text-gray-100">{cluster.competitorCount}</div>
        </div>
        <div>
          <div className="flex items-center gap-1">
            <span className="h-2 w-2 rounded-full bg-gray-400" />
            <span className="text-gray-500 dark:text-gray-400">Open</span>
          </div>
          <div className="font-medium text-gray-900 dark:text-gray-100">{cluster.openCount}</div>
        </div>
      </div>
      <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
        {cluster.totalSchools} total &middot; {cluster.penetrationPct}% penetration
      </div>
    </div>
  );
}
